/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Utterance } from './Utterance.js';
import {
    UtteranceFromJSON,
    UtteranceFromJSONTyped,
    UtteranceToJSON,
} from './Utterance.js';

/**
 * 
 * @export
 * @interface PartialUtterance
 */
export interface PartialUtterance {
    /**
     * 
     * @type {string}
     * @memberof PartialUtterance
     */
    partialId?: string;
    /**
     * 
     * @type {Utterance}
     * @memberof PartialUtterance
     */
    utterance?: Utterance;
}

/**
 * Check if a given object implements the PartialUtterance interface.
 */
export function instanceOfPartialUtterance(value: object): boolean {
    return true;
}

export function PartialUtteranceFromJSON(json: any): PartialUtterance {
    return PartialUtteranceFromJSONTyped(json, false);
}

export function PartialUtteranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialUtterance {
    if (json == null) {
        return json;
    }
    return {
        
        'partialId': json['partialId'] == null ? undefined : json['partialId'],
        'utterance': json['utterance'] == null ? undefined : UtteranceFromJSON(json['utterance']),
    };
}

export function PartialUtteranceToJSON(value?: PartialUtterance | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'partialId': value['partialId'],
        'utterance': UtteranceToJSON(value['utterance']),
    };
}

